__webpack_require__.p = "https://pharmacy-stage.curebay.in/";